import { render, staticRenderFns } from "./ModalDoctor.vue?vue&type=template&id=c1e4d47a"
import script from "./ModalDoctor.vue?vue&type=script&lang=js"
export * from "./ModalDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports